<template>
  <component :is="dominioData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
        variant="danger"
        :show="dominioData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
            class="alert-link"
            :to="{ name: 'apps-dominio-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <b-tabs
        v-if="dominioData"
        pills
    >

      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
              icon="UserIcon"
              size="16"
              class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Dominios</span>
        </template>
        <DominioEditTabInformation
            :dominio-data="dominioData"
            class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue';
import { ref, onUnmounted } from '@vue/composition-api';
import router from '@/router';
import store from '@/store';
import dominioStoreModule from '../dominioStoreModule';
import DominioEditTabInformation from './DominioEditInformation.vue';

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    DominioEditTabInformation,
  },
  setup() {
    const dominioData = ref(null);

    const USER_APP_STORE_MODULE_NAME = 'app-dominio';

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, dominioStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    store.dispatch('app-dominio/fetchDominio', { id: router.currentRoute.params.id })
      .then((response) => {
        dominioData.value = response.data.data;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          dominioData.value = undefined;
        }
      });

    return {
      dominioData,
    };
  },
};
</script>

<style>

</style>
